import classNames from "classnames"
import React, {PropsWithChildren} from "react"
import {IcomoonIconName} from "../../components/Icon/icons"
import CardIcon from "./CardIcon"

interface Props {
	title?: string | JSX.Element
	subtitle?: string | JSX.Element
	className?: string
	icon?: IcomoonIconName | JSX.Element
	/** Render only the card element (for use inside a parent `.column` grid). */
	nested?: boolean
}

export type CardProps = PropsWithChildren<Props>

export default function Card({title, subtitle, className, icon, nested, children}: CardProps) {
	const card = (
		<div className={classNames("card", nested && className)}>
			{title && (
				<div className="card-header">
					{typeof title === "string" ? (
						<p className="card-header-title">
							{" "}
							{icon && <CardIcon icon={icon} />} {title}
						</p>
					) : (
						<div className="card-header-title card-header-title-block">
							{" "}
							{icon && <CardIcon icon={icon} />} {title}
						</div>
					)}
				</div>
			)}
			{title && subtitle && <div className="card-subtitle">{subtitle}</div>}
			<div className="card-content">{children}</div>
		</div>
	)

	if (nested) {
		return card
	}

	return (
		<div className={classNames("columns", !nested && className)}>
			<div className="column">{card}</div>
		</div>
	)
}
